<template>
    <div class="statistics-browser">
        <table>
            <tr>
                <!--<th>App</th>-->
                <th>Time</th>
                <th>Version</th>
                <th>Header</th>
                <th>Message</th>
                <th>Session</th>
            </tr>
            <tr v-for="stat in statistics" :key="stat.UnixTime">
                <!--<td>{{ stat.AppId }}</td>-->
                <td>{{ stat.friendlyTime }}</td>
                <td>{{ stat.AppVersion }}</td>
                <td>{{ stat.Header }}</td>
                <td>{{ stat.Message }}</td>
                <td :class="calculateSessionGroup(stat.SessionId)">{{ stat.SessionId }}</td>
            </tr>
        </table>
        <div class="pagination">
            <!--<button class="btn-small" @click="previousPage" :disabled="statistics.length === 0 || currentPage === 1">Previous</button>-->
            <button class="btn-small" @click="previousPage" :disabled="paginationKeys.length <= 1">{{ $t('prev-page')}}</button>
            <button class="btn-small align-right" @click="nextPage" :disabled="!nextKey">{{ $t('next-page')}}</button>
        </div>
    </div>
</template>

<script>

import superagent from 'superagent';
import constants from '@/Constants.js';

export default {
    async mounted() {
        //this.fetchStatistics(this.app);
        this.nextPage();
    },
    props: ['app'],
    methods: {
        // Add any methods you need here
        async fetchStatistics(filterApp = null, startFrom = null) {
            try {

                const query = {app: filterApp};
                if (startFrom) query.startFrom = startFrom;
                query.limit = 20;
                const result = await superagent.get(`${constants.apiUrl}/statistics`)
                    .set('Authorization', localStorage.getItem('token'))
                    .query(query)
                    .send();

                this.statistics = result.body.items;
                this.statistics.forEach((item) => {
                    item.friendlyTime = new Date(item.UnixTime * 1000).toLocaleString();
                });
                this.nextKey = result.body.lastEvaluatedKey ? result.body.lastEvaluatedKey.UnixTime : null;

            } catch (e) {
                console.error(e);
                // Assume log out?
            }
        },

        async nextPage() {
            this.paginationKeys.push(this.nextKey);
            await this.fetchStatistics(this.app, this.nextKey);
            this.currentPage++;
        },

        async previousPage() {
            this.paginationKeys.pop();
            const prevKey = this.paginationKeys[this.paginationKeys.length - 1];
            await this.fetchStatistics(this.app, prevKey);
            this.currentPage--;
        },

        calculateSessionGroup(sessionId) {
            const sessionGroup = parseInt('0x'+sessionId.replaceAll('-','')) % 14;
            return `session-group-${sessionGroup}`;
        }
    },
    data () {
        return {
            statistics: [],
            paginationKeys: [],
            nextKey: null,
            currentPage: 0
        }
    }
}
</script>

<style scoped>
.btn-small {
    margin: 20px;
}
.align-right {
    float: right;
}

.session-group-0 {
    color: #005B9A;
}

.session-group-1 {
    color: #4354D4;
}

.session-group-2 {
    color: #183885;
}

.session-group-3 {
    color:  #53B2F0;
}

.session-group-4 {
    color: #71CAD8;
}

.session-group-5 {
    color: #1E1BC3;
}

.session-group-6 {
    color: 	#E70CD7;
}

.session-group-7 {
    color: 	#F276D8;
}

.session-group-8 {
    color: #5CA3F4;
}

.session-group-9 {
    color: #315DDF;
}

.session-group-10 {
    color: #1EEC76;
}

.session-group-11 {
    color: #1AFDD5;
}

.session-group-12 {
    color: #449CFF;
}

.session-group-13 {
    color: #9C3AEE;
}
</style>

